<template>
  <div>
    <el-form :inline="true" class="selectForm">
      <el-select
        v-model="searchForm.schoolName"
        placeholder="筛选学校信息"
        @change="selectSchool"
        clearable>
        <el-option
          v-for="item in searchForm.schoolOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.building"
        placeholder="筛选寝室楼信息"
        @change="selectBuilding"
        clearable>
        <el-option
          v-for="item in searchForm.buildingOptions"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.room"
        placeholder="筛选寝室信息"
        @change="reloadTableData"
        clearable>
        <el-option
          v-for="item in searchForm.roomOption"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select
        v-model="searchForm.payYear"
        placeholder="选择支付年度"
        @change="reloadTableData"
        clearable>
        <el-option
          v-for="item in searchForm.payYearOption"
          :key="item"
          :value="item">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        @click="downloadTable"
        icon="el-icon-document"
        :loading="downloadLoading">
        下载
      </el-button>
      <!--<el-select-->
        <!--v-model="searchForm.roomStatus"-->
        <!--placeholder="筛选寝室状态"-->
        <!--@change="reloadTableData"-->
        <!--clearable>-->
        <!--<el-option-->
          <!--v-for="item in searchForm.roomStatusOption"-->
          <!--:key="item"-->
          <!--:value="item">-->
        <!--</el-option>-->
      <!--</el-select>-->
    </el-form>
    <el-table
      :data="tableData"
      border
      stripe
      v-loading="tableLoading"
      height="300px"
      element-loading-text="拼命加载中">
      <el-table-column prop="schoolName" label="学校"></el-table-column>
      <el-table-column prop="building" label="寝室楼"></el-table-column>
      <el-table-column prop="room" label="寝室号"></el-table-column>
      <el-table-column prop="stuNameDesen" label="付款者"></el-table-column>
      <el-table-column prop="stuid" label="学号"></el-table-column>
      <el-table-column prop="payTime" label="付款时间"></el-table-column>
      <el-table-column prop="outTradeNo" label="交易订单号"></el-table-column>
      <el-table-column prop="statusDesc" label="订单状态"></el-table-column>
      <el-table-column prop="payYear" label="支付年度"></el-table-column>
    </el-table>
    <el-pagination
      @current-change="currentChange"
      @size-change="sizeChange"
      :page-sizes="[5, 10,15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      :total=pagination.total>
    </el-pagination>
  </div>
</template>

<script>
import { axiosByJson, axiosByKeyValue } from '../axios/index';

export default {
  name: 'StudentPay',
  data() {
    return {
      searchForm: {
        schoolName: '',
        building: '',
        room: '',
        roomStatus: '',
        payYear: '',
        schoolOptions: [],
        buildingOptions: [],
        roomOption: [],
        payYearOption: [],
        roomStatusOption: ['租赁中', '空置中'],
      },
      tableData: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      tableLoading: false,
      downloadLoading: false,
      dialogVisible: false,
      dialogForm: {
        gender: '0',
        number: 1,
      },
    };
  },
  methods: {
    initSchoolOption() {
      axiosByJson.post('listSchoolStudentPay').then(({ data: { data } }) => {
        this.searchForm.schoolOptions = data;
      });
    },
    initPayYearOption() {
      axiosByJson.post('listSchoolStudentPayYear').then(({ data: { data } }) => {
        this.searchForm.payYearOption = data;
      });
    },
    initBuildingOption() {
      axiosByKeyValue.post('listBuildingStudentPay', {
        schoolName: this.searchForm.schoolName,
      }).then(({ data: { data } }) => {
        this.searchForm.buildingOptions = data;
      });
    },
    initRoomOption() {
      axiosByKeyValue.post('listRoomStudentPay', {
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
      }).then(({ data: { data } }) => {
        this.searchForm.roomOption = data;
      });
    },
    sizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.reloadTableData();
    },
    currentChange(currentPage) {
      this.pagination.pageNo = currentPage;
      this.reloadTableData();
    },
    selectSchool(value) {
      this.searchForm.building = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.buildingOptions = [];
      } else {
        this.initBuildingOption();
      }
    },
    selectBuilding(value) {
      this.searchForm.room = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    selectBuildingStatus(value) {
      this.searchForm.roomStatus = '';
      this.reloadTableData();
      if (value === '') {
        this.searchForm.roomOption = [];
      } else {
        this.initRoomOption();
      }
    },
    reloadTableData() {
      this.tableLoading = true;
      axiosByJson.post('listStudentPay', {
        pageNo: this.pagination.pageNo,
        pageSize: this.pagination.pageSize,
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
        room: this.searchForm.room,
        payYear: this.searchForm.payYear,
      }).then(({ data: { data: { count, list } } }) => {
        list.forEach((val) => {
          Object.assign(val, {
            statusDesc: val.status === 'PENDING' ? '待支付' : '已支付',
            stuNameDesen: val.stuName == null ? null : val.stuName.substring(0, 1) + '**',
          });
        });
        this.tableData = list;
        this.pagination.total = count;
        this.tableLoading = false;
      });
    },
    downloadTable() {
      this.downloadLoading = true;
      axiosByJson.post('listStudentPay', {
        pageNo: 0,
        pageSize: this.pagination.pageSize,
        schoolName: this.searchForm.schoolName,
        building: this.searchForm.building,
        room: this.searchForm.room,
        payYear: this.searchForm.payYear,
      }).then(({ data: { data: { list } } }) => list).then((data) => {
        const csvContentHeader = 'data:text/csv;charset=utf-8,\uFEFF';
        let csvContent = '';
        const header = '学校,寝室楼,寝室号,付款者,学号,付款时间,交易订单号,订单状态,支付年度';
        csvContent += `${header}\r\n`;
        data.forEach((rowObj) => {
          const row = `${rowObj.schoolName},${rowObj.building},${rowObj.room},${rowObj.stuName},${rowObj.stuid},${rowObj.payTime},${rowObj.outTradeNo == null ? '' : '`' + rowObj.outTradeNo},${rowObj.status === 'PENDING' ? '待支付' : '已支付'},${rowObj.payYear},`;
          csvContent += `${row}\r\n`;
        });
        csvContent = encodeURIComponent(csvContent);
        const encodedUri = csvContentHeader + csvContent;
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', '订单导出.csv');
        document.body.appendChild(link);
        link.click();
        this.downloadLoading = false;
      });
    },
    editDormitory(row) {
      Object.assign(this.dialogForm, row, { gender: row.gender.toString() });
      this.dialogVisible = true;
    },
  },
  created() {
    this.reloadTableData();
    this.initSchoolOption();
    this.initPayYearOption();
  },
};
</script>

<style scoped>
  .selectForm {
    text-align: center;
    margin-bottom: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/components/StudentPay.vue